import { InviteSync } from '@/app/sync/invite';
import { handleDeleteChatClick } from '@/features/chats/sub-features/chat-info/utils/deleteChatConfirm';
import { useChatRequest } from '@/features/chats/viewmodels';
import { handleToggleBlockClick } from '@/features/users';
import { useLanguage } from '@/localization/useLanguage';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import './requestChatBanner.scss';

export const RequestChatBanner = ({ chatJid }) => {
   const { t } = useLanguage();
   const { isReceiver } = useChatRequest(chatJid);

   const handleAccept = useCallback(() => {
      InviteSync.acceptRequest(chatJid);
   }, [chatJid]);

   const handleDelete = useCallback(() => {
      handleDeleteChatClick({ onConfirm: () => InviteSync.rejectRequest(chatJid) });
   }, [chatJid]);

   const handleBlock = useCallback(
      e => {
         handleToggleBlockClick({ e, jid: chatJid });
      },
      [chatJid],
   );

   if (!isReceiver) return null;

   return (
      <div className="request-chat-banner ct-flex ct-fcol ct-aiCenter">
         <p className="request-chat-banner__text">{t('invite.BANNER_TEXT')}</p>
         <div className="request-chat-banner__actions ct-flex ct-aiCenter ct-jcCenter">
            <button className="request-chat-banner__btn request-chat-banner__btn--block" onClick={handleBlock}>
               {t('chat.BLOCK')}
            </button>
            <button className="request-chat-banner__btn request-chat-banner__btn--delete" onClick={handleDelete}>
               {t('chat.DELETE')}
            </button>
            <button
               className="request-chat-banner__btn request-chat-banner__btn--accept ct-flex ct-aiCenter ct-jcCenter"
               onClick={handleAccept}
            >
               {t('common.ACCEPT')}
            </button>
         </div>
      </div>
   );
};

RequestChatBanner.propTypes = {
   chatJid: PropTypes.string.isRequired,
};
